import _ from "lodash";

export const getDeletableEvent = (items) => {
    const rows = _.map(items, (item, index) => {
      const renderedCells = _.reduce(
        item.original,
        (result, value, key) => {
          if (
            _.includes(
              ["id", "title", "event_start_timestamp", "panelist_card_title"],
              key
            )
          ) {
            const textValue = _.get(value, "props.text") || value;
           
              result.push(<td key={key}>{textValue}</td>);
  
          }
          return result;
        },
        []
      );
  
      return <tr key={index}>{renderedCells}</tr>;
    });
  
    const tableHeaders = (
      <thead>
        <tr>
          <th>Title</th>
          <th>Panelist Section Title</th>
          <th>Event Start Time</th>
          <th>Id</th>
        </tr>
      </thead>
    );
  
    return (
      <div>
        <table className={"table mp-content-v2-preview-table small"}>
          {tableHeaders}
          <tbody>{rows}</tbody>
        </table>
      </div>
    );
  };
  